<p-floatlabel variant="on">
  <p-select
    [options]="companies$ | async"
    [(ngModel)]="selectedCompany"
    optionLabel="name"
    dataKey="id"
    (onChange)="onChangeCompany($event)"
    appendTo="body"
    [dropdownIcon]="(loading$ | async) ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-down'"
  ></p-select>
  <label>{{ 'core.companySelector.label' | translate }}</label>
</p-floatlabel>
